// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"236":"af5d9e35","452":"c43ee9a8","453":"2c5e4f4e","975":"d0bbcca0"}[chunkId] + ".chunk.js";
};